import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ui-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  @Input() title = 'Are you sure?';
  @Input() message = 'This action cannot be undone.';
  @Input() confirmButtonText = 'Confirm';
  @Input() confirmButtonClass = 'btn-primary';
  @Input() cancelButtonText = 'Cancel';
  @Input() cancelButtonClass = 'btn-secondary';

  @Output() confirmAction = new EventEmitter<void>();
  @Output() cancelAction = new EventEmitter<void>();

  @ViewChild('modalTemplate', { static: true })
  modalTemplate!: TemplateRef<unknown>;

  private modalRef?: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  open(): void {
    this.modalRef = this.modalService.open(this.modalTemplate, {
      centered: true,
      backdrop: 'static',
    });
  }

  close(): void {
    this.modalRef?.close();
  }

  onConfirm(): void {
    this.close();
    this.confirmAction.emit();
  }

  onCancel(): void {
    this.close();
    this.cancelAction.emit();
  }
}
